const localStorageManger = stateNodeName => {
	return {
		values: (adminId) => {
			try {
				const data = JSON.parse(localStorage.getItem(stateNodeName));
				return data[adminId] || null;
			} catch (e) {
				return null;
			}
		},
		setData: (adminId) => (key, value) => {
			// @todo if need save multiple merge with prev
			localStorage.setItem(stateNodeName, JSON.stringify({
				[adminId]: {
					[key]: value
				}
			}));
		}
	};
};
export default localStorageManger;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/local-storage.js